import React from 'react';
import FadeInImage from '../components/FadeInImage';
import ContentLayout from '../layout/ContentLayout';
import michaelImage from '../img/michael.jpg';
import mikeyImage from '../img/mikey.jpg';
import './MeetTheTeamPage.css';

function MeetTheTeamPage() {
	return (
		<ContentLayout contentHeader={'Meet the team'}>
			<div className='team-members'>
				<article className='team-member'>
					<FadeInImage
						src={michaelImage}
						alt='Michael Warburton'
						className='team-image'
					/>
					<h2 className='team-name'>Michael Warburton</h2>
					<p className='content-paragraph team-bio'>
						Michael is a Bristol-based multi-instrumentalist and singer with several
						years of experience working with children with special educational
						needs in the UK and Quebec.
						For Michael, folk music belongs to everyone. He finds that folk
						music, song, and dance is unique in the way that it meets the
						listener, learner or participant on their own terms. Anybody of any
						age or any capacity can make it, move to it, or be moved by it at a
						level that suits them.
						He first fell in love with music as a child through a couple of
						one-off assemblies in his state school from a local silver band. He
						hopes our work in schools might mean something similar for the young
						people participating.
					</p>
				</article>

				<article className='team-member'>
					<FadeInImage
						src={mikeyImage}
						alt='Mikey Ponsford'
						className='team-image team-image-left team-image-mikey'
					/>
					<h2 className='team-name'>Mikey Ponsford</h2>
					<p className='content-paragraph team-bio'>
						Mikey hails from deepest darkest west Cornwall and has been leading
						music workshops and performing for over 15 years. His voice and
						mandolin have taken him all around Europe, Australia and America,
						including playing at the Royal Albert Hall and the Minnack Theatre.
						His background is primarily in American folk and Bluegrass music,
						but he has been known to dabble in a plethora of acoustic genres.
						Mikey lives for songwriting, telling stories through music and
						sharing moments of spontaneous joy.
					</p>
				</article>
			</div>
		</ContentLayout>
	);
}

export default MeetTheTeamPage;
